import { __assign, __awaiter, __generator } from "tslib";
import { useCallback } from "react";
import { useAuthData } from "../providers/AuthDataProvider";
import { ACCESS_STATUSES, useViewer } from "../providers/ViewerProvider";
import { callAPI } from "../helpers/callAPI";
export var useOrderProductPanelCard = function () {
    var token = useAuthData().token;
    var _a = useViewer(), siteId = _a.siteId, setViewerData = _a.setViewerData;
    var fetchOrderProduct = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var configuration, site, properties, _a, status_1, error_1;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!token) {
                        throw new Error("No token");
                    }
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    configuration = {
                        method: "POST",
                        url: "/clients/entities/update",
                        cache: true,
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                        data: {
                            type: "Site",
                            id: siteId,
                            data: {
                                attributes: {
                                    thingEquirectangularMedia: {
                                        values: [
                                            {
                                                value: ACCESS_STATUSES.ordered,
                                                locale: "de-DE",
                                                source: "internal",
                                            },
                                        ],
                                    },
                                },
                            },
                        },
                    };
                    return [4 /*yield*/, callAPI(configuration)];
                case 2:
                    site = (_e.sent()).data;
                    properties = (((_d = (_c = (_b = site === null || site === void 0 ? void 0 : site.data) === null || _b === void 0 ? void 0 : _b.attributes.thingEquirectangularMedia) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d[0]) || {}).properties;
                    _a = (properties || {}).referenceDataIdentifier, status_1 = _a === void 0 ? ACCESS_STATUSES.demo : _a;
                    setViewerData(function (prev) { return (__assign(__assign({}, prev), { status: status_1 })); });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _e.sent();
                    // eslint-disable-next-line no-console
                    console.error(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [token, siteId, setViewerData]);
    return {
        fetchOrderProduct: fetchOrderProduct,
    };
};
